import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { readProject } from '../../modules/project/projectSlice';
import ProjectViewer from './ProjectViewer';
import ProjectActionButtons from '../../components/project/ProjectActionButtons';
import { setOriginalProject, } from '../../modules/project/projectWriteSlice';
import { removeProject } from '../../modules/project/projectAPI';

const ProjectViewerContainer = () => {
    // 처음 마운트될 때 프로젝트 읽기 API 요청
    const { projectId } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const project = useSelector(state => state.project.project);
    const error = useSelector(state => state.project.error);
    const loading = useSelector(state => state.loading);
    const user = useSelector(state => state.user.user);
    const language = useSelector(state => state.language.language);

    useEffect(() => {
        // 프로젝트를 DB에서 읽어와서 성공하면 스토어 project.project에, 실패하면 project.error에 쓴다.
        dispatch(readProject(projectId));

        // 언마운트될 때 리덕스에서 프로젝트 데이터 없애기
        // return () => {
        //     dispatch(unloadProject());
        // };
    }, [dispatch, projectId]);

    const onEdit = () => {
        // 스토어의 project를 가지고 와서 store의 write에 쓴 후 상기 useEffect에서 unloadProject 액션 디스패치한다.
        dispatch(setOriginalProject(project));
        navigate('/write/project');
    };

    const onRemove = async () => {
        try {
            await removeProject(projectId);
            navigate(-1);
        } catch (e) {
            console.error(e);
        }
    };

    const ownProject = (user && user._id) === (project && project.user._id);

    return (
        <ProjectViewer
            loading={!loading}
            error={error}
            project={project}
            ownProject={!!ownProject}
            actionButtons={!!ownProject && <ProjectActionButtons onEdit={onEdit} onRemove={onRemove} language={language} />}
        />
    );
};

export default React.memo(ProjectViewerContainer);
